export const DASHBOARD_ROUTE = '/dashboard';
export const ERROR_ROUTE = '*';

export const BASE_WAREHOUSE_PATH = '/managedinventory';
export const OLD_WAREHOUSE_PATH = '/mobileinventory';

// Mobile inventory routes
export const MANAGED_INVENTORY_ROUTES = {
  DASHBOARD: `${BASE_WAREHOUSE_PATH}/dashboard`,
  TRANSFER: `${BASE_WAREHOUSE_PATH}/transfer`,
  COUNTER: `${BASE_WAREHOUSE_PATH}/counter`,
  SETTINGS: `${BASE_WAREHOUSE_PATH}/settings`,
  PICKING: `${BASE_WAREHOUSE_PATH}/picking`,
  HANDLING: `${BASE_WAREHOUSE_PATH}/handling`,
  KITTING: `${BASE_WAREHOUSE_PATH}/kitting`,
  RECEIVE: `${BASE_WAREHOUSE_PATH}/receive`,
  SHIP: `${BASE_WAREHOUSE_PATH}/ship`,
  SHIPPING: `${BASE_WAREHOUSE_PATH}/shipping`,
  STOCK_LOTS: `${BASE_WAREHOUSE_PATH}/stock-lots`,
  STOCK_LOCATIONS: `${BASE_WAREHOUSE_PATH}/stock-locations`,
  PRE_RECEIVE: `${BASE_WAREHOUSE_PATH}/pre-receive`,
  MANUAL_RECEIVE: `${BASE_WAREHOUSE_PATH}/manual-receive`,
  FIXED_RECEIVE: `${BASE_WAREHOUSE_PATH}/fixed-receive`,
  INLINE_RECEIVE: `${BASE_WAREHOUSE_PATH}/inline-receive`,
  FIXED_PICKING: `${BASE_WAREHOUSE_PATH}/fixed-picking`,
  MOBILE_PICKING: `${BASE_WAREHOUSE_PATH}/mobile-picking`,
  KIT_DASHBOARD: `${BASE_WAREHOUSE_PATH}/kit-dashboard`,
  ERROR: '*',
};

// Old mobile inventory routes for redirects
export const OLD_MANAGED_INVENTORY_ROUTES = {
  DASHBOARD: `${OLD_WAREHOUSE_PATH}/dashboard`,
  TRANSFER: `${OLD_WAREHOUSE_PATH}/transfer`,
  COUNTER: `${OLD_WAREHOUSE_PATH}/counter`,
  SETTINGS: `${OLD_WAREHOUSE_PATH}/settings`,
  PICKING: `${OLD_WAREHOUSE_PATH}/picking`,
  HANDLING: `${OLD_WAREHOUSE_PATH}/handling`,
  KITTING: `${OLD_WAREHOUSE_PATH}/kitting`,
  RECEIVE: `${OLD_WAREHOUSE_PATH}/receive`,
  SHIP: `${OLD_WAREHOUSE_PATH}/ship`,
  SHIPPING: `${OLD_WAREHOUSE_PATH}/shipping`,
  STOCK_LOTS: `${OLD_WAREHOUSE_PATH}/stock-lots`,
  STOCK_LOCATIONS: `${OLD_WAREHOUSE_PATH}/stock-locations`,
  PRE_RECEIVE: `${OLD_WAREHOUSE_PATH}/pre-receive`,
  MANUAL_RECEIVE: `${OLD_WAREHOUSE_PATH}/manual-receive`,
  FIXED_RECEIVE: `${OLD_WAREHOUSE_PATH}/fixed-receive`,
  INLINE_RECEIVE: `${OLD_WAREHOUSE_PATH}/inline-receive`,
  FIXED_PICKING: `${OLD_WAREHOUSE_PATH}/fixed-picking`,
  MOBILE_PICKING: `${OLD_WAREHOUSE_PATH}/mobile-picking`,
  KIT_DASHBOARD: `${OLD_WAREHOUSE_PATH}/kit-dashboard`,
};

export const AUTH_ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT: '/forgot',
  AUTH_FAIL: '/auth-fail',
  // This is for setting password from an authenticated email route,
  // changing password when authenticated happens in another UX,
  // and resetting password when unauthenticated happens in another route
  RESET: '/set-password',
};

// NOTE: Should we break these into app related constants.ts files?

// Parts Constants
export const PARTS_TABS = {
  SOURCING: 'sourcing',
  PURCHASING: 'purchasing',
  QUOTES: 'quotes',
  PURCHASE_REQUESTS: 'purchase_requests',
  PURCHASE_ORDERS: 'purchase_orders',
  ORDERS: 'orders',
  BOMS: 'boms',
  INVENTORY: 'inventory',
  ALTERNATIVES: 'alternatives',
  HEALTH: 'health',
  COMPLIANCE: 'compliance',
  SPECIFICATIONS: 'specifications',
  DOWNLOADS: 'downloads',
};

export const PARTS_V2_TABS = {
  ...PARTS_TABS,
  PART_INFO: 'part-info',
};

export const PRODUCTION_RUNS_TABS_MAP = {
  STATUS: 'status',
  PARTS: 'parts',
  PURCHASING: 'purchasing',
  RELATED: 'related',
  SETTINGS: 'settings',
};
